
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CommentsToggleProps {
  commentCount: number;
  onClick: () => void;
}

export const CommentsToggle = ({ commentCount, onClick }: CommentsToggleProps) => {
  return (
    <Button
      variant="ghost"
      className="w-full text-gray-400 hover:text-white flex items-center justify-center gap-2 py-1.5 text-xs"
      onClick={onClick}
    >
      <MessageCircle className="w-3 h-3" />
      View {commentCount} {commentCount === 1 ? 'comment' : 'comments'}
    </Button>
  );
};
